import {
  DIARY_SLOT_SEARCH_REQUEST,
  DIARY_SLOT_SEARCH_SUCCESS,
  DIARY_SLOT_SEARCH_FAIL,
  DIARY_SLOT_CHECK_AVAILABILITY_REQUEST,
  DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS,
  DIARY_SLOT_CHECK_AVAILABILITY_FAIL,
  DIARY_SLOT_UPDATE_REQUEST,
  DIARY_SLOT_UPDATE_SUCCESS,
  DIARY_SLOT_UPDATE_FAIL,
  DIARY_SLOT_BOOK_REQUEST,
  DIARY_SLOT_BOOK_SUCCESS,
  DIARY_SLOT_BOOK_FAIL,
} from "./actionType";

const initialState = {
  diarySlotList: [],
  diarySlotLoading: false,
  diarySlotError: null,

  availabilityResults: [],
  availabilityLoading: false,
  availabilityError: null,

  bookingLoading: false,
  bookingResult: null,
  bookingError: null,
};

const DiarySlot = (state = initialState, action) => {
  switch (action.type) {
    case DIARY_SLOT_SEARCH_REQUEST:
      return { ...state, diarySlotLoading: true, diarySlotError: null };

    case DIARY_SLOT_SEARCH_SUCCESS:
      return {
        ...state,
        diarySlotLoading: false,
        diarySlotList: action.payload?.diaryslot_list || [],
      };

    case DIARY_SLOT_SEARCH_FAIL:
      return { ...state, diarySlotLoading: false, diarySlotError: action.payload };

    case DIARY_SLOT_CHECK_AVAILABILITY_REQUEST:
      return { ...state, availabilityLoading: true, availabilityError: null, availabilityResults: [] };

    case DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availabilityLoading: false,
        availabilityResults: action.payload?.availability_results || [],
      };

    case DIARY_SLOT_CHECK_AVAILABILITY_FAIL:
      return { ...state, availabilityLoading: false, availabilityError: action.payload };

    case DIARY_SLOT_UPDATE_REQUEST:
      return { ...state, slotUpdateLoading: true, slotUpdateError: null, slotUpdateResult: null };

    case DIARY_SLOT_UPDATE_SUCCESS:
      // The meta rides through so the board knows which drag this answers.
      return {
        ...state,
        slotUpdateLoading: false,
        slotUpdateResult: action.payload,
        slotUpdateMeta: action.meta || null,
      };

    case DIARY_SLOT_UPDATE_FAIL:
      return {
        ...state,
        slotUpdateLoading: false,
        slotUpdateError: action.payload,
        slotUpdateMeta: action.meta || null,
      };

    case DIARY_SLOT_BOOK_REQUEST:
      return { ...state, bookingLoading: true, bookingResult: null, bookingError: null };

    case DIARY_SLOT_BOOK_SUCCESS:
      return { ...state, bookingLoading: false, bookingResult: action.payload };

    case DIARY_SLOT_BOOK_FAIL:
      return { ...state, bookingLoading: false, bookingError: action.payload };

    default:
      return state;
  }
};

export default DiarySlot;
